import type { ReviewedStepEnum } from '~/shared/api/data-ingestion-api/client'

export const FLAG_TYPES = {
  CREDIT_CARD: 'credit_card',
  PATIENT_CLAIM: 'patient_claim',
  STEP_CLASSIFICATION: 'step_classification',
  STEP_DATA: 'step_data',
  STEP_CARC_RARC: 'step_carc_rarc',
  STEP_PATIENT: 'step_patient',
  STEP_EOB_DUPLICATION: 'step_eob_duplication',
  STEP_EOB_PAYMENT_DEPOSIT: 'step_eob_payment_deposit',
  STEP_EOB_PROCESSING: 'step_eob_processing',
} as const

export type StepFlagType =
  | typeof FLAG_TYPES.STEP_CLASSIFICATION
  | typeof FLAG_TYPES.STEP_DATA
  | typeof FLAG_TYPES.STEP_CARC_RARC
  | typeof FLAG_TYPES.STEP_PATIENT
  | typeof FLAG_TYPES.STEP_EOB_DUPLICATION
  | typeof FLAG_TYPES.STEP_EOB_PAYMENT_DEPOSIT
  | typeof FLAG_TYPES.STEP_EOB_PROCESSING

export const STEP_FLAG_TYPE_TO_REVIEWED_STEP: Record<StepFlagType, ReviewedStepEnum> = {
  [FLAG_TYPES.STEP_CLASSIFICATION]: 'classification',
  [FLAG_TYPES.STEP_DATA]: 'data',
  [FLAG_TYPES.STEP_CARC_RARC]: 'carc_rarc',
  [FLAG_TYPES.STEP_PATIENT]: 'patient',
  [FLAG_TYPES.STEP_EOB_DUPLICATION]: 'eob_duplication',
  [FLAG_TYPES.STEP_EOB_PAYMENT_DEPOSIT]: 'eob_payment_deposit',
  [FLAG_TYPES.STEP_EOB_PROCESSING]: 'eob_processing',
}
